// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__12N3a","rootCenter":"LoadMoreObserver_rootCenter__2q-vQ","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2SS3D"};